import React from "react";
import { GrChatOption } from "react-icons/gr";

const BookAppointmentButton = ({
  name = "Schedule a Consultation",
  bgColor = "bg-rose-500",
  textColor = "text-white",
  textHoverColor = "text-black",
  showIcon = false,
  hoverColor = "hover:bg-blue-800",
  paddingx = "px-4",
  paddingy = "py-2",
}) => {
  return (
    <div
      className={`group relative inline-block self-start rounded-sm ${bgColor}  p-2 transition duration-500 ease-in-out ${hoverColor}  px-4 py-2`}
    >
      {showIcon && <GrChatOption size={30} />}
      <p
        className={`${paddingx} ${paddingy} text-center font-bold ${textColor} ${textHoverColor}`}
      >
        {name}
      </p>
    </div>
  );
};

export default BookAppointmentButton;
